import React from 'react';
import { motion } from 'framer-motion';
import { MailIcon, LinkedinIcon, MapPinIcon } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-24 bg-gradient-to-br from-primary-dark via-primary to-primary text-white" data-id="element-1">
      <div className="max-w-[1100px] mx-auto px-6 md:px-12" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center text-center" data-id="element-3">
          <h2 className="font-serif text-4xl md:text-5xl font-bold mb-8" data-id="element-4">
            Get in Touch
          </h2>
          <p className="font-sans text-slate-300 max-w-xl mb-12 font-light leading-relaxed" data-id="element-5">
            Available for executive advisory, board positions, and strategic
            consulting opportunities in risk management and treasury operations.
          </p>

          <div className="flex flex-col md:flex-row items-center gap-8 mb-16" data-id="element-6">
            <a href="mailto:Casciari4@aol.com" className="flex items-center gap-3 text-slate-200 hover:text-white transition-colors group" data-id="element-7">
              <div className="w-10 h-10 rounded-full border border-slate-700 flex items-center justify-center group-hover:border-accent group-hover:bg-accent/10 transition-all" data-id="element-8">
                <MailIcon size={18} data-id="element-9" />
              </div>
              <span className="font-sans text-sm tracking-wide" data-id="element-10">Email Me</span>
            </a>

            <a href="https://linkedin.com/in/joe-casciari-69125413" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-slate-200 hover:text-white transition-colors group" data-id="element-11">
              <div className="w-10 h-10 rounded-full border border-slate-700 flex items-center justify-center group-hover:border-accent group-hover:bg-accent/10 transition-all" data-id="element-12">
                <LinkedinIcon size={18} data-id="element-13" />
              </div>
              <span className="font-sans text-sm tracking-wide" data-id="element-14">LinkedIn</span>
            </a>

            <div className="flex items-center gap-3 text-slate-200" data-id="element-15">
              <div className="w-10 h-10 rounded-full border border-slate-700 flex items-center justify-center" data-id="element-16">
                <MapPinIcon size={18} data-id="element-17" />
              </div>
              <span className="font-sans text-sm tracking-wide" data-id="element-18">
                New York City Metropolitan Area
              </span>
            </div>
          </div>

          <div className="w-full h-px bg-slate-800 mb-8" data-id="element-19"></div>

          <div className="flex flex-col md:flex-row justify-between items-center w-full text-xs text-slate-500 font-sans tracking-wide" data-id="element-20">
            <p data-id="element-21">
              © {new Date().getFullYear()} Joe Casciari. All rights reserved.
            </p>
            <p className="mt-2 md:mt-0" data-id="element-22">Senior Risk & Treasury Executive</p>
          </div>
        </motion.div>
      </div>
    </section>;
}